import appGlobalScript from '/__w/12174/s/packages/core/src/utils/global.ts';
export const globalScripts = appGlobalScript;
